import { render, staticRenderFns } from "./AdminPointsProfile.vue?vue&type=template&id=1ea68a00&"
import script from "./AdminPointsProfile.vue?vue&type=script&lang=js&"
export * from "./AdminPointsProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports